// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jt-0";
export var buttonContainer = "_jt-3";
export var cancelButton = "_jt-4";
export var headerSection = "_jt-6";
export var headerTitle = "_jt-9";
export var messageSideLeft = "_jt-1";
export var messageSideRight = "_jt-2";
export var orderNumberContainer = "_jt-7";
export var orderNumberLabel = "_jt-8";
export var submitButton = "_jt-5";